import * as React from 'react';
import Modal, { ModalSize } from './modal';
import { NotesModalBody } from './NotesModalBody';
import { SessionNote, SubjectNote, TestNote } from 'webportalclient';
import { AuditModal } from '../../auditmodal/components/AuditModal';

export interface NotesModalProps {
    header: string;
    isVisible: boolean;
    isAddingNote: boolean;
    disabled: boolean;
    notes: SessionNote[] | SubjectNote[] | TestNote[];
    errorStatus?: string | undefined;
    onAdd?: (annotation: string) => void;
    onEdit?: (id: string, comment: string, annotation: string) => void;
    onCloseModal: () => void;
    changeButtonText?: string;
    notificationBanner?: JSX.Element;
    comparisonNotes?: { title: string, items: SessionNote[] | SubjectNote[] | TestNote[] }[] | undefined;
    comparisonColumnHeader?: string;
    modalSize?: ModalSize;
}

export const NotesModal = (props: NotesModalProps) => {
    const [confirmed, setConfirmed] = React.useState(false);
    const [submitting, setSubmitting] = React.useState(false);
    const [auditModalVisible, setAuditModalVisible] = React.useState(false);
    const [toEditNoteId, setToEditNoteId] = React.useState<string>();
    const [toEditNote, setToEditNote] = React.useState<string>();


    const onHandleModalSubmit = async (annotation: string) => {
        setSubmitting(true);
        props.onEdit(toEditNoteId, toEditNote, annotation);
        setSubmitting(false);
        setToEditNoteId(undefined);
        setToEditNote(undefined);
        setAuditModalVisible(false)
        props.onCloseModal();
    }

    if (props.isVisible) {
        return (
            <Modal show={true} header={props.header} size={props.modalSize ?? ModalSize.Normal} closeModalHandler={() => props.onCloseModal()} automationId="NotesModal">
                {props.notificationBanner}
                {auditModalVisible ?
                    <AuditModal isSubmitting={submitting} onSubmit={(form) => onHandleModalSubmit(form.Annotation)} onClose={() => {
                        setAuditModalVisible(false)
                        props.onCloseModal();
                    }} header="Update Note" />
                    :
                    <NotesModalBody
                        notes={props.notes}
                        isAddingNote={props.isAddingNote}
                        disabled={props.disabled}
                        errorStatus={props.errorStatus}
                        onAdd={props.onAdd}
                        onEdit={props.onEdit ? (id, comment) => {
                            setToEditNoteId(id)
                            setToEditNote(comment)
                            setAuditModalVisible(true)
                        }: undefined}
                        onCloseModal={props.onCloseModal}
                        changeButtonText={props.changeButtonText}
                        comparisonNotes={props.comparisonNotes}
                        comparisonColumnHeader={props.comparisonColumnHeader}
                    />
                }
            </Modal>
        );
    } else {
        return null;
    }
}
